module.exports = __webpack_public_path__ + "static/media/illustration-mobile.73c575eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/illustration-mobile.svg
// module id = 1925
// module chunks = 0